<template>
  <div>
    <!-- <div class="fixed top-0 left-0 z-30 bg-gray-600 opacity-75 min-w-full w-screen h-screen" /> -->

    <div
      class="fixed bottom-0 right-0 z-40 min-w-full w-screen flex"
    >
      <div class="w-2/12" />
      <div
        class="w-10/12 flex items-end"
        style="box-shadow: 15px 10px 15px 5px rgba(0, 0, 0, 0.1), 0 4px 6px 5px rgba(0, 0, 0, 0.05), 0 4px 6px 5px rgba(0, 0, 0, 0.05), 0 4px 6px 5px rgba(0, 0, 0, 0.05);"
      >
        <div
          class="w-full min-w-full bg-gray-50 border-t"
        >
          <div class="flex items-center justify-between bg-white p-3 pl-4 pr-4 text-sm border-b shadow-sm ">
            <div class="px-4 sm:px-6 lg:mx-auto lg:px-8 max-w-7xl flex justify-between w-full items-center">
              <div class="flex">
                <div class="text-gray-700 font-semibold border-r pr-4">
                  Booking
                </div>
                <div class="flex pl-4 items-center">
                  <div class="flex items-center leading-none">
                    <i class="fad fa-calendar-day text-gray-500 text-xs mr-1" />
                    {{ teeTimeToBook.teeTime.time | moment("Do, MMMM YYYY") }}
                    <!-- <i class="fas fa-caret-down leading-none text-gray-500 text-sm ml-2"></i> -->
                  </div>

                  <div class="flex items-center leading-none ml-4">
                    <i class="fad fa-clock text-gray-500 text-xs mr-1" />
                    {{ teeTimeToBook.teeTime.time | moment("HH:mm") }}
                    <!-- <i class="fas fa-caret-down leading-none text-gray-500 text-sm ml-2"></i> -->
                  </div>

                  <div
                    v-if="teeTimeToBook.numOfPlayers > 0"
                    class="flex items-center leading-none ml-4"
                  >
                    <i class="fad fa-users text-gray-500 text-xs mr-1" />
                    {{ teeTimeToBook.numOfPlayers }} Player<span v-if="teeTimeToBook.numOfPlayers > 1">s</span>
                    <!-- <i class="fas fa-caret-down leading-none text-gray-500 text-sm ml-2"></i> -->
                  </div>
                </div>
              </div>

              <div class="flex space-x-2">
                <SecondaryButton
                  text="Close"
                  padding="py-1 px-2"
                  :disabled="loading"
                  @click="close()"
                />
                <SecondaryButton
                  text="Block"
                  padding="py-1 px-2"
                  :disabled="loading"
                  @click="blockSlots()"
                />
                <PrimaryButton
                  text="Save"
                  padding="py-1 px-2"
                  :disabled="loading"
                  @click="book()"
                />
              </div>
            </div>
          </div>

          <div class="w-full min-w-full relative">
            <div
              class="flex justify-center lg:mx-auto lg:px-4 max-w-7xl pt-2 pb-2"
            >
              <div
                v-for="(player, index) in bookedPlayers"
                class="p-3 pl-4"
                :class="getWidth()"
              >
                <PlayerSelection
                  class="border-r pr-6 border-gray-200"
                  :label="'Player ' + (index + 1)"
                  placeholder="Name"
                  :index="index"
                  :default-player="player"
                  @input="playerInput"
                  @removePlayer="removePlayer"
                />
              </div>

              <div
                v-for="index in teeTimeToBook.numOfPlayers"
                class="p-3 pl-4"
                :class="getWidth()"
              >
                <PlayerSelection
                  class="border-r pr-6 border-gray-200"
                  :label="'Player ' + (index + bookedSlots)"
                  placeholder="Name"
                  :index="index"
                  @input="playerInput"
                />
              </div>

              <div
                v-for="index in remainingSlots"
                class="p-3 pl-4 "
                :class="getWidth()"
              >
                <div
                  class="w-full min-w-full h-full min-h-full flex justify-center items-center text-gray-400 hover:text-gray-600
                  transition-all duration-500 cursor-pointer border-gray-200"
                  :class="index !== remainingSlots? 'border-r pr-6' : '' "
                  @click="addPlayer(index)"
                >
                  <div class="h-48 flex items-center">
                    <i class="fad fa-plus text-2xl" />
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="loading"
              class="absolute top-0 left-0 bg-gray-600 z-20 bg-opacity-50 w-full h-full flex items-center justify-center"
            >
              <LoadingSpinner class="-ml-6" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PrimaryButton from '@/app/shared/components/base/button/primaryButton.vue';
import SecondaryButton from '@/app/shared/components/base/button/secondaryButton.vue';
import { CreateBooking } from '@/app/shared/services/bookingService/bookingService';
import LoadingSpinner from '@/app/shared/components/base/loading/loadingSpinner.vue';
import PlayerSelection from './playerSelection.vue';

export default {
  name: 'BookingPanel',

  components: {
    PlayerSelection,
    PrimaryButton,
    SecondaryButton,
    LoadingSpinner,
  },

  props: {
    teeTimeToBook: {
      type: Object,
      default: null,
    },
    config: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      players: [],
      loading: false,
    };
  },

  computed: {
    ...mapState({
      selectedCourse: state => state.course.selectedCourse,
    }),

    remainingSlots() {
      return this.teeTimeToBook.teeTime.availability - this.teeTimeToBook.numOfPlayers;
    },

    bookedSlots() {
      return this.config.maxPlayers - this.teeTimeToBook.teeTime.availability;
    },

    bookedPlayers() {
      const players = [];

      this.teeTimeToBook.teeTime.bookings.forEach((booking) => {
        booking.players.forEach((player) => {
          const bookedPlayer = player;
          bookedPlayer.bookingId = booking.id;
          players.push(bookedPlayer);
        });
      });

      return players;
    },
  },

  methods: {
    blockSlots() {
      const slots = [];

      // eslint-disable-next-line no-plusplus
      for (let i = 1; i <= this.teeTimeToBook.numOfPlayers; i++) {
        slots.push({ name: 'System', type: 6 });
      }

      this.book(slots);
    },

    book(players) {
      if (this.players.length > 0 || players.length > 0) {
        this.loading = true;
        CreateBooking(this.selectedCourse.id, this.teeTimeToBook.teeTime.time, players === undefined ? this.players : players).then((data) => {
          if (players !== null) {
            this.$emit('silentRefresh');
          } else {
            this.$emit('success');
          }
        })
        .catch((error) => {
          alert('Cannot book this slot');
        })
        .finally(() => {
          this.loading = false;
        });
      } else {
        this.$emit('close');
      }
    },

    getWidth() {
      if (this.config !== null) {
        if (this.config.maxPlayers <= 1) {
          return 'w-full';
        } if (this.config.maxPlayers === 2) {
          return 'w-1/2';
        } if (this.config.maxPlayers === 3) {
          return 'w-1/3';
        } if (this.config.maxPlayers === 4) {
          return 'w-1/4';
        }
      } else {
        return 'w-full';
      }
    },

    removePlayer(playerId) {
      this.$emit('removePlayer', playerId);
    },

    addPlayer(index) {
      if (this.remainingSlots > 0) {
        this.teeTimeToBook.numOfPlayers = this.teeTimeToBook.numOfPlayers + index;
      }
    },

    playerInput(input) {
      this.players[(input.index - 1)] = input.player;
    },

    close() {
      this.$emit('close');
    },
  },
};
</script>
